export default {
    SET_CARE_GIVER_DATA(state, payload) {
        state.careGiverData = payload;
    }
};
